<template>
	<section class="block-credit credit">

	</section>
</template>

<script>
import Mixin from "../common/mixin";
import finance from "../common/finance";

export default {
	name: "block-credit",
	mixins: [finance, Mixin],
};
</script>

<style lang="scss" scoped>

</style>
